module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external "baglass/core-client/js/core-client/ui/properties/PropertyUIControl"
// module id = 50
// module chunks = 0 1